import * as Api from "../../api";
import Utils from "../../untils";
import Vue from "vue";

const state = {};

const getters = {};

const mutations = {};

const actions = {
  sendRequestAgentKitEmail({ state }, { pat, callback }) {
    let obj = {
      action: `/api/agent/requestAgentKit`,
      firstName: pat.firstName,
      lastName: pat.lastName,
      companyName: pat.companyName,
      state: pat.state,
      email: pat.email,
      phoneNumber: pat.phoneNumber,
      message: pat.message,
    };
    Api.requestbody(obj, { show: false }).then(resp => {
      if (callback) {
        callback(resp, "agentKitEmailCallback");
      }
    });
  },

  sendRequestToJoinUConnectEmail({ state }, { pat, callback }) {
    console.log("pat: ", pat);
    let obj = {
      action: `/api/agent/requestUConnectKit`,
      firstName: pat.firstName,
      lastName: pat.lastName,
      companyName: pat.companyName,
      state: pat.state,
      email: pat.email,
      phoneNumber: pat.phoneNumber,
      message: pat.message,
    };
    Api.requestbody(obj, { show: false }).then(resp => {
      if (callback) {
        callback(resp, "joinUConnectEmailCallback");
      }
    });
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};



// WEBPACK FOOTER //
// ./src/store/modules/request.js